<template>
  <hic-dialog :visible="visible" title="编辑信息" @close="cancel" @open="open" :close-on-click-modal="false" width="75rem">
    <el-form :model="value" ref="editor" :rules="comRules" label-width="7rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="8">
            <el-form-item label="姓名" prop="patientName">
                <el-input size="small" type="text" placeholder="请输入编码"
                    v-model.trim="infoDetail.patientName"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="性别" prop="patientGender">
              <hic-dict-selector dict-type="Gender" placeholder="请选择性别" v-model="infoDetail.patientGender" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="年龄" prop="patientAge">
                <el-input size="small" type="text" placeholder="请输入年龄" v-model.trim="infoDetail.patientAge" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="联系电话" prop="phone">
                <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="infoDetail.phone" />
            </el-form-item>
        </el-col>
        <el-col :span="16">
            <el-form-item label="住址" prop="address">
                <el-input size="small" type="text" placeholder="请输入详细住址" v-model.trim="infoDetail.address" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="西医诊断" prop="">
              <el-input size="small" type="text" placeholder="请输入诊断内容" v-model.trim="infoDetail.diagnosis" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="中医诊断" prop="">
              <el-input size="small" type="text" placeholder="请输入诊断内容" v-model.trim="infoDetail.diagnosisChn" />
            </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
            <el-form-item label="会诊" prop="">
              <el-checkbox v-model="infoDetail.ifConsultation">是否会诊</el-checkbox>
            </el-form-item>
        </el-col> -->
   
        <el-col :span="8">
          <el-form-item label="会诊专科" prop="">
            <el-input size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.specialized" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="会诊二三线" prop="">
              <el-input size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.secondOrThirdTier" />
            </el-form-item>
        </el-col>
        
        <el-col :span="16">
            <el-form-item label="初诊" prop="">
              <el-radio-group v-model="infoDetail.ifSubsequent">
                <el-radio :label="false">初诊</el-radio>
                <el-radio :label="true">复诊</el-radio>
              </el-radio-group>
              <el-input class="edit-thin left-pad" v-if="infoDetail.ifSubsequent" size="small" type="number" placeholder="复诊次数" v-model.trim="infoDetail.repeatDiagnoses	" ><span slot="prefix">第</span><span slot="suffix">次</span></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="绿色通道" prop="">
              <el-checkbox v-model="infoDetail.ifGreenChannel"></el-checkbox>
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="群伤" prop="">
              <el-checkbox v-model="infoDetail.ifCrowdHarm"></el-checkbox>
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="危重等级" prop="">
              <hic-dict-selector dict-type="CriticalLevel" is-enum placeholder="请选择性别" v-model="infoDetail.criticalLevel" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="手术名称" prop="">
                <el-input size="small" type="text" placeholder="请输入" v-model.trim="infoDetail.surgeryName" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="手术分级" prop="">
              <hic-dict-selector dict-type="SurgeryGrade" placeholder="请选择手术分级" v-model="infoDetail.surgeryGrade" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="中医特殊治疗" prop="">
                <el-input size="small" type="text" placeholder="请输入" v-model.trim="infoDetail.chineseTreat" />
            </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="转归" prop="">
                <el-checkbox v-model="infoDetail.ifConsultation">会诊<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.consultationMemo" /></el-checkbox>
                <el-checkbox v-model="infoDetail.ifObservation">留观<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.observationMemo" /></el-checkbox>
                <el-checkbox v-model="infoDetail.ifRescue">抢救<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.rescueMemo" /></el-checkbox>
                <el-checkbox v-model="infoDetail.ifIp">住院<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.ipMemo" /></el-checkbox>
                <el-checkbox v-model="infoDetail.ifTransfer">转院<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.transferMemo" /></el-checkbox>
                <el-checkbox v-model="infoDetail.ifDead">死亡<el-input class="memo" size="small" type="text" placeholder="请输入内容" v-model.trim="infoDetail.deadMemo" /></el-checkbox>
                <!-- <el-input size="small" type="text" placeholder="请输入内容" v-model.trim="ReversionText" /> -->
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="传染病报卡" prop="">
                <el-input size="small" type="text" placeholder="请输入" v-model.trim="infoDetail.infectiousDiseaseCard" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="不良事件" prop="">
                <el-input size="small" type="text" placeholder="请输入" v-model.trim="infoDetail.adverseEvent" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="输血" prop="">
                <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="infoDetail.bloodTransfusion" />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="首诊医生" prop="">
              <hic-staff-selector v-model="infoDetail.doctorCode" :name.sync="infoDetail.doctorName" auto />
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="备注" prop="">
                <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="infoDetail.bookMemo" />
            </el-form-item>
        </el-col>
        
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" >确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  // const Reversions = [{name:'ifConsultation',text:'consultationMemo'},{name:'ifObservation',text:'observationMemo'},{name:'ifRescue',text:'rescueMemo'},{name:'ifIp',text:'ipMemo'},{name:'ifTransfer',text:'transferMemo'},{name:'ifDead',text:'deadMemo'}]
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
      infoDetail:Object
    },
    data() {
      return {
        // Reversion:"",
        ReversionText:"",
        meta:{
          loading: false,
        },
        comRules: {
          patientName: [{required: true,message: "请输入名称",trigger: "blur"}],
          // patientGender: [{required: true,message: "请选择性别",trigger: "change"}],
          phone: [{required: true,message: "请输入联系电话",trigger: "blur"}],
          address: [{required: true,message: "请输入详细住址",trigger: "blur"}],
          // shortCode: [{required: true,message: "请输入助记码",trigger: "blur"}],
          // unit: [{required: true,message: "请输入单位",trigger: "blur"}],
          // type: [{required: true,message: "请选择分类",trigger: "change"}],
          
          // startDate: [{required: true,message: "请选择启用日期",trigger: "change"}],
          // endDate: [{required: true,message: "请选择停用日期",trigger: "change"}],
          // price: [{required: true,message: "请输入价格",trigger: "blur"},{ validator: price, trigger: 'blur' }],
          // seqNo: [{ validator: numRex, trigger: 'blur' }],

      },
      };
    },
    computed: {
    },
    methods: {
      open(){
        // Reversions.forEach(res=>{
        //   if(this.infoDetail[res.name]){
        //     this.Reversion = res.name
        //     this.ReversionText = this.infoDetail[res.text]
        //   }
        // })
      },
      save() {
        this.meta.loading = true;
        api.OpTreatment.save(this.infoDetail).then(res => {
          if(res.code == -1) return this.$message.error('保存失败');
          this.$emit("close");
          this.cancel()
        }).catch(err => {
          if (err && err != "cancel") {
            this.$message.error(err.message || err);
          }
        }).finally(()=>{
          this.meta.loading = false;
        })
      },
      cancel() {
        this.$emit("update:visible", false);
        // this.$emit("cancel");
      },
    },
  };
</script>
<style scoped>
.memo{
  width: 80%;
  margin-left: 10px;
}
</style>
